import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { PageHeader } from "@/components/app/UI";

export default function WhatsAppLog() {
  const [log, setLog] = useState([]);
  useEffect(() => { api.get("/whatsapp/log").then((r) => setLog(r.data)); }, []);

  return (
    <div data-testid="whatsapp-page">
      <PageHeader
        eyebrow="Notifications"
        title="WhatsApp Log"
        subtitle="All outgoing messages — quotations, payment reminders, installation schedules. MOCKED for Phase 1."
      />
      <div className="p-4 sm:p-8">
        <div className="border border-[#E5E7EB] overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F9FAFB] border-b border-[#E5E7EB]">
              <tr>
                {["When", "Category", "Recipient", "Message", "Status"].map((h) => (
                  <th key={h} className="text-left label-eyebrow !text-[10px] px-4 py-3">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {log.map((m) => (
                <tr key={m.id} className="border-b border-[#F3F4F6]" data-testid={`whatsapp-row-${m.id}`}>
                  <td className="px-4 py-3 text-xs">{fmtDate(m.at)}</td>
                  <td className="px-4 py-3 text-xs font-bold">{m.category}</td>
                  <td className="px-4 py-3 text-xs font-mono">{m.recipient || "—"}</td>
                  <td className="px-4 py-3 text-xs">{m.message}</td>
                  <td className="px-4 py-3">
                    <span className="text-[10px] uppercase tracking-wider font-bold bg-[#FEF3C7] text-[#92400E] px-2 py-0.5">{m.status}</span>
                  </td>
                </tr>
              ))}
              {log.length === 0 && <tr><td colSpan={5} className="text-center text-sm text-[#9CA3AF] py-12">No notifications yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
